import { SortOrder } from "../sort-order";

export class MeasurementTypeFilters {
  sensor: string;
  unit: string;
  dataType: string;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
